<div class="table-header py-3 px-3">
    <div class="header-content">
        <h2 class="table-title">{{ 'app.billing.invoices.title' | translate }}</h2>
        <button mat-icon-button (click)="reload.emit()"
            class="d-flex align-items-center justify-content-center focus-outline-none"
            [matTooltip]="'shared.general.tooltips.refresh' | translate" [disabled]="isLoading()">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
    @if (count()) {
    <div class="count-line">
        <span class="count-badge">{{ count() }}</span>
        <span class="count-label">{{ 'app.billing.invoices.found_suffix' | translate }}</span>
    </div>
    }
</div>
<div class="table-wrapper">
    <table mat-table [dataSource]="invoices()">
        <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.index' | translate }}</th>
            <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.date' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.period_start | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="plan">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.plan' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.plan_name ?? ('shared.general.labels.na' | translate) }}</td>
        </ng-container>

        <ng-container matColumnDef="seats">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.seats' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.seat_count }}</td>
        </ng-container>

        <ng-container matColumnDef="devices">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.devices' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.device_count }}</td>
        </ng-container>

        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.amount' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.total | currency: row.currency : 'symbol' : '1.2-2' }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.status' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                @let tip = tooltip(row);

                <span class="av-billing-status-cell">
                    <span class="av-billing-badge" [class]="'av-billing-badge--' + statusClass(row)">
                        {{ statusKey(row) | translate }}
                    </span>
                    @if (tip) {
                    <mat-icon class="av-billing-status-cell__info" [matTooltip]="tip">info_outline</mat-icon>
                    }
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="invoice">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.invoice' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                @if (row.invoice_pdf_url) {
                <a mat-icon-button color="primary" [href]="row.invoice_pdf_url" target="_blank" rel="noopener"
                    [matTooltip]="'app.billing.actions.download_invoice' | translate">
                    <mat-icon>download</mat-icon>
                </a>
                } @else {
                <span class="av-billing-note">-</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="receipt">
            <th mat-header-cell *matHeaderCellDef>{{ 'app.billing.invoices.columns.receipt' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                @if (row.receipt_url) {
                <a mat-icon-button color="primary" [href]="row.receipt_url" target="_blank" rel="noopener"
                    [matTooltip]="'app.billing.actions.download_receipt' | translate">
                    <mat-icon>download</mat-icon>
                </a>
                } @else {
                <span class="av-billing-note">-</span>
                }
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    @if (invoices().length === 0) {
    <div class="no-data-content mt-5 pt-5">
        @if (isLoading()) {
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'app.billing.invoices.loading' | translate }}</span>
        } @else {
        <span>{{ 'app.billing.invoices.empty' | translate }}</span>
        }
    </div>
    }

    <app-table-loading-bar [isLoading]="isLoading()"></app-table-loading-bar>
</div>

@if (count() > 0) {
<mat-paginator class="pagination-bar" [length]="count()" [pageIndex]="pageIndex()" [pageSize]="pageSize()"
    [pageSizeOptions]="[pageSize()]" [hidePageSize]="true" [showFirstLastButtons]="true"
    (page)="onPage($event)"></mat-paginator>
}
